export const DEFAULT_IFRAME_HEIGHT: string = '100%'
export const IFRAME_SCALE: number = 0.64
export const SHADOW_DOM_ZOOM_VALUE = 64
